// extracted by mini-css-extract-plugin
module.exports = {"clouds":"clouds-module--clouds--3vfMU","previousBlue":"clouds-module--previousBlue--1drGU","inverted":"clouds-module--inverted--1gkaG"};